// Allow the HTML <title> tag to be updated or cleared from anywhere in the app
// Always prepend the name of the site
export const setPageTitle = (title: string) => {
  let pageTitle = process.env.VUE_APP_SITE_TITLE;
  if (title) {
    pageTitle += ` | ${title}`;
  }
  document.title = pageTitle;
};
